import { render, staticRenderFns } from "./UserGuides.vue?vue&type=template&id=fa1532cc"
import script from "./UserGuides.vue?vue&type=script&lang=js"
export * from "./UserGuides.vue?vue&type=script&lang=js"
import style0 from "./UserGuides.vue?vue&type=style&index=0&id=fa1532cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports